import { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    course: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbxuKs6ZeP7hDKHofP4l-8NGGlI0zYUIEhwH5P2aSwjx9WVkj1X69P-kP3HhC2Dril7--g/exec";

  const normalizePhone = (phone) => {
    const digits = phone.replace(/\D/g, "");

    if (digits.length === 10) return `+91${digits}`;
    if (digits.length === 12 && digits.startsWith("91")) return `+${digits}`;

    return "";
  };

  const isValidPhone = (phone) => {
    const normalized = normalizePhone(phone);
    return /^\+91[6-9]\d{9}$/.test(normalized);
  };

  const handleChange = (e) => {
    let value = e.target.value;

    if (e.target.name === "phone") {
      value = value.replace(/[^\d+]/g, "");
    }

    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    if (!isValidPhone(formData.phone)) {
      alert("Please enter a valid Indian phone number.");
      return;
    }

    const cleanPhone = normalizePhone(formData.phone);

    setLoading(true);
    setSuccess(false);

    try {
      await fetch(SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...formData,
          phone: cleanPhone
        })
      });

      setSuccess(true);

      setFormData({
        name: "",
        phone: "",
        course: "",
        message: ""
      });

      setTimeout(() => {
        setSuccess(false);
      }, 3000);
    } catch (error) {
      console.log("Form submit error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact section" id="contact">
      <div>
        <p className="sectionTag">Contact Us</p>
        <h2>Visit Orion Academy</h2>

        <p><b>Branches:</b> Colaba | Charni Road</p>

        <p>
          <b>Address:</b> 1B, Goverdhan Bhavan, 3rd Pasta Lane,
          Opp. Bharat Gas, Colaba Market, Mumbai-05
        </p>

        {/* SEO location line */}
        <p>
          Orion Academy is located in Colaba Mumbai and is one of the top coaching classes for school, commerce and science students.
        </p>

        <p><b>Call:</b> 7498678737 / 8452965550</p>
        <p><b>Website:</b> www.orionacademyedu.com</p>
        <p><b>Instagram:</b> @orionacademy16</p>
        <p><b>Email id:</b> orionacademy1042016@gmail.com</p>

        <div className="mapBox">
          <iframe
            title="Orion Academy Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.295766714323!2d72.82463737373196!3d18.91829825690729!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7d1cb09314563%3A0x3c0abf01bc78db38!2sOrion%20Academy%20(Your%20trust%20is%20our%20success)!5e0!3m2!1sen!2sin!4v1777233052248!5m2!1sen!2sin"
            width="100%"
            height="260"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <form className="contactForm" onSubmit={handleSubmit}>
        <h2 className="contactHeading">Book Your Free Demo</h2>
        <p className="contactSub">Fill the form and we will contact you soon</p>

        {success && (
          <p className="successMsg">Enquiry Submitted Successfully ✅</p>
        )}

        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
          value={formData.name}
          onChange={handleChange}
        />

        <input
          type="tel"
          name="phone"
          placeholder="Your Phone"
          required
          value={formData.phone}
          onChange={handleChange}
        />

        <select
          name="course"
          required
          value={formData.course}
          onChange={handleChange}
        >
          <option value="">Select Batch</option>
          <option value="School Batch">School Batch</option>
          <option value="Commerce">Commerce</option>
          <option value="Science">Science</option>
          <option value="VCR / Regular Batch">VCR / Regular Batch</option>
        </select>

        <textarea
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
        ></textarea>

        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Send Message"}
        </button>
      </form>

      <a
        className="whatsapp"
        href="https://wa.me/917498678737"
        target="_blank"
        rel="noreferrer"
      >
        <FaWhatsapp size={28} color="white" />
      </a>
    </section>
  );
}

export default Contact;